import { ListItem, ListItemIcon, ListItemText, Pill, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { type CaseData } from "../types";

interface CaseNotesListItemProps {
  caseData: CaseData;
}

export function CaseNotesListItem(props: CaseNotesListItemProps) {
  const { caseData } = props;

  const notes = caseData.attributes.description ?? "This patient has no additional information";

  return (
    <ListItem divider>
      <ListItemIcon iconType="pencil" />
      <ListItemText
        disableTypography
        primary={
          <Text semibold variant="h6" sx={{ textWrap: "balance" }}>
            Notes
          </Text>
        }
        secondary={
          <Stack spacing={4} marginTop={2}>
            <Text variant="body2">{notes}</Text>
            <Stack direction="row" spacing={2}>
              {caseData.attributes.specialties.map((specialty) => (
                <Pill
                  key={specialty}
                  backgroundColor={(theme) => theme.palette.background.quaternary}
                  label={specialty}
                />
              ))}
            </Stack>
          </Stack>
        }
      />
    </ListItem>
  );
}
